import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_934_1465)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.33334 25C8.33334 21.6848 9.6503 18.5054 11.9945 16.1612C14.3387 13.817 17.5181 12.5 20.8333 12.5H79.1667C82.4819 12.5 85.6613 13.817 88.0055 16.1612C90.3497 18.5054 91.6667 21.6848 91.6667 25V66.6667C91.6667 69.9819 90.3497 73.1613 88.0055 75.5055C85.6613 77.8497 82.4819 79.1667 79.1667 79.1667H47.2208L33.3333 89.5833C29.9 92.1583 25 89.7083 25 85.4167V79.1667H20.8333C17.5181 79.1667 14.3387 77.8497 11.9945 75.5055C9.6503 73.1613 8.33334 69.9819 8.33334 66.6667V25Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.8875 86.8333H38.3875L37.9874 87.1333L24.1 97.55C24.1 97.55 24.1 97.55 24.0999 97.55C21.6555 99.3833 18.1667 97.6389 18.1667 94.5833V88.3333V86.8333H16.6667H12.5C9.58262 86.8333 6.78473 85.6744 4.72183 83.6115C2.65893 81.5486 1.5 78.7507 1.5 75.8333V34.1666C1.5 31.2492 2.65893 28.4514 4.72183 26.3885C6.78473 24.3256 9.58262 23.1666 12.5 23.1666H70.8333C73.7507 23.1666 76.5486 24.3256 78.6115 26.3885C80.6744 28.4514 81.8333 31.2492 81.8333 34.1666V75.8333C81.8333 78.7507 80.6744 81.5486 78.6115 83.6115C76.5486 85.6744 73.7507 86.8333 70.8333 86.8333H38.8875Z",
			fill: "white",
			stroke: "#5151F9",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_934_1465",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 100,
				height: 100,
				fill: "white"
			})
		}) })
	]
});
export default SvgMessage;
